import { render, staticRenderFns } from "./CardTree.vue?vue&type=template&id=19fab50b&"
import script from "./CardTree.vue?vue&type=script&lang=js&"
export * from "./CardTree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports